module.exports = __webpack_public_path__ + "static/media/bgi_d_salary_levels@2x.158f640e.png";